import {Injectable} from '@angular/core';
import {Service} from '../common/service.class';
import {UserModelService} from '../common/user-model.service';
import {AdminReports} from './admin-reports.model';

@Injectable()
export class AdminReportsService extends UserModelService<AdminReports> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'adminReports', AdminReports);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/admin-reports/admin-reports.service.ts